import { Moment } from 'moment';
import { SchedulerEventType } from 'components/organisms/resource-management/event-types';
import { AllocationEventModel } from 'components/organisms/resource-management/scheduler-config/models';
import { useTranslate } from 'hooks/use-translation';
import { allocationTooltip } from './allocation-template';
import { projectPhaseTooltip } from './project-phase-template';
import { projectTimelineTooltip } from './project-timeline-template';

export const tooltipForEvent = (
  event: AllocationEventModel,
  relativeDate: Moment,
  translate: ReturnType<typeof useTranslate>,
  isHoursPerWeek?: boolean,
): string | null => {
  switch (event.get('type')) {
    case SchedulerEventType.ProjectPhase:
      return projectPhaseTooltip(
        {
          phaseName: event.get('phaseName'),
          startDate: event.startDate as Date,
          endDate: event.endDate as Date,
        },
        relativeDate,
        translate,
      );
    case SchedulerEventType.Allocation:
      return allocationTooltip(
        {
          startDate: event.startDate as Date,
          endDate: event.endDate as Date,
          projectPhase: event.get('projectPhase'),
          billable: event.get('billable'),
          totalMinutes: event.get('totalMinutes'),
          minutes: event.get('minutes'),
        },
        relativeDate,
        translate,
        isHoursPerWeek,
      );
    case SchedulerEventType.ProjectTimeline:
      return projectTimelineTooltip(
        {
          startDate: event.startDate as Date,
          endDate: event.endDate as Date,
        },
        relativeDate,
        translate,
      );

    default:
      return null;
  }
};
